import { makeAutoObservable } from 'mobx'
import { InferenceStore } from 'store/inference/InferenceStore'

export class ExistingStore {
  inference: InferenceStore

  constructor(inference: InferenceStore) {
    this.inference = inference
    makeAutoObservable(this)
  }
}
